import React, { useEffect, useState } from 'react';
import { MenuPlacement } from 'react-select';

import { Select } from '@components/common';

import { TSelectOption } from '@interfaces/components/componentTypes';

interface IFileOptionsProps {
	onSelectChange: (option: TSelectOption<string>) => void;
	isError: boolean;
	menuPlacement: MenuPlacement;
	selectOptions: Array<TSelectOption>;
	value: TSelectOption;
	isCommonDirty: boolean;
}

const FileOptions = ({
	onSelectChange,
	isError,
	menuPlacement,
	selectOptions,
	value,
	isCommonDirty,
}: IFileOptionsProps) => {
	const [isDirty, setIsDirty] = useState(false);

	useEffect(() => setIsDirty(isCommonDirty), [isCommonDirty]);

	const onBlur = () => setIsDirty(true);

	return (
		<Select
			handleChange={onSelectChange}
			isClearable
			isError={isDirty && isError}
			isWithoutUseForms
			menuPlacement={menuPlacement}
			name='selectField'
			onBlur={onBlur}
			options={selectOptions}
			value={value}
			width='240px'
		/>
	);
};

export default FileOptions;
